const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export function formatDate(date: Date) {
  return `${MONTHS[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
}

export function formatDateShort(date: Date) {
  const month = date.getMonth() + 1;
  return `${date.getDate()}/${
    month < 10 ? '0' : ''
  }${month}/${date.getFullYear()}`;
}
